import Vue from 'vue'

import byProductSSF from '@/components/pages/supplier-search/routes/byProductSSF.vue'
import originSSF from '@/components/pages/supplier-search/routes/originSSF.vue'

import { FormModeType, PurchaseType } from '@/types/supplier-search'
import { getNewStore } from '@/store/supplier-search'

import Vuelidate from 'vuelidate'

const byProductSSFStore = getNewStore({ type: PurchaseType.SupplierFinder });
const originSSFStore = getNewStore({ type: PurchaseType.SupplierFinder });

import { ProductMainInfo, ProductCharacteristicTypes } from '@/types/supplier-search'

const productFormCollection = document.getElementsByClassName('vue-js-supplier-search');
const originFormCollection = document.getElementsByClassName('vue-js-origin-supplier-search');

window.supplierSearchEventBus = new Vue();

Vue.use(Vuelidate);

const renderByProductSSF = () => {
	new Vue({
		store: byProductSSFStore,
		data() {
			return {
				formModeType: FormModeType.ByProduct
			}
		},
		validations: {},
		render: h => h(byProductSSF)
	}).$mount('.vue-js-supplier-search');
}

const renderOriginSSF = () => {
	new Vue({
		store: originSSFStore,
		data() {
			return {
				formModeType: FormModeType.Origin
			}
		},
		validations: {},
		render: h => h(originSSF)
	}).$mount('.vue-js-origin-supplier-search');
}

window.supplierSearchEventBus.$on('render-supplier-search', renderByProductSSF)
window.supplierSearchEventBus.$on('RENDER_ORIGIN_SUPPLIER_SEARCH_FORM', renderOriginSSF) //SSF

if (originFormCollection.length > 0) {
	renderOriginSSF();
}

if (productFormCollection.length > 0) {
	renderByProductSSF();
}

if (process.env.VUE_APP_IS_LOCAL_DEBUG === 'true') {
	const dataFromTradeRegistry: ProductMainInfo = {
		ProductId: 123,
		ProductName: 'Курятник каркасный',
		ProductSource: 'fromMerchant',
		ImageUrl: 'https://stable-market.otc.ru/microservices-tender/merchant/Photo/GetPhoto/?id=448300',
		Price: 0,
		UnitName: 'метр',
		UnitShortName: 'м',
		UnitCode: '796',
		CurrencyCode: '643',
		Quantity: 100,
		TaxPercent: 22,
		ProductUrl: 'http://lol-kek.ru/poductId=123',
		Okpd2: '',
		Okpd2Code: '',
		Okved2: '',
		Okved2Code: '',
		Category: 'Шкатулки',
		SearchKeyword: '',
		DeliveryAddress: [{ Name: 'Пенза', Code: '031020303' }, { Name: 'Самара', Code: '3123123123' }], //возможно будет
		SearchQuery: 'https://otc.ru/tenders?searchform.state=1&searchform.keywordslist=33123&searchform.keywordslist=Шляпы&searchform.documentsearchenabled=true',
		SupplierOrganization: {
			OrganizationName: 'Спортсервис',
			CommonOrganizationId: 3,
			Inn: '',
			Kpp: '',
			Ogrn: '',
			Email: 'newemail@ew.ru',
			Phone: '',
			Address: ''
		},
		ProductCharacteristic: [
			{
				UnitName: 'байт',
				UnitShortName: 'бт',
				UnitCode: '3312',
				Comment: '',
				Name: 'Цвет',
				Value: {
					Value: '1',
					Type: ProductCharacteristicTypes.String
				}
			},
			{
				UnitName: 'киллограмм',
				UnitShortName: 'м',
				Comment: '',
				UnitCode: '312',
				Name: 'Длина',
				Value: {
					Value: 2,
					Type: ProductCharacteristicTypes.Integer
				}
			}
		]
	}
	//stable
	//9643386075
	//3438

	//local
	//784229411
	//4
	window.supplierSearchEventBus.$emit('show-supplier-search-window', dataFromTradeRegistry);
}